/**
 *  Sagas for the ResourceNames resource managment using Swagger client
 *
 * Each saga watcher intercepts a trigger action, does the asyncrhonous work in the respective worker saga and dispatches a success or a failure action.
 * Fetch calls are made via the swagger tags interface requests
 *
 */

import { apiClient, applyHeaders, buildHeaders } from "@bkry/bowline-utils";
import { call, put, takeEvery } from "redux-saga/effects";
import { actions } from "./index";
import { getCachedPayload } from "../cachedPayload";

/** Show Saga
 *  @description: connects to the showAnalytic operation
 *  @param {number} action.payload the Analytic id
 */
export function* show(action) {
  let headers = yield buildHeaders();
  let { projectId, metricSlug, filters } = action.payload;

  const apiRequest = function* () {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.Analytics.showAnalyticsForProject,
      {
        project_id: projectId,
        metric_slug: metricSlug,
        ...filters,
        cumulative: !!filters?.cumulative,
      },
      {
        requestInterceptor: applyHeaders(headers),
      }
    );
    return payload;
  };
  const successActions = function* (payload) {
    // we skip here the includes because we dont want to override our current project
    yield put(actions.showSuccess(payload));
  };
  const failActions = function* (e) {
    yield put(actions.showFail({ message: e.message, ...e }));
  };
  yield* getCachedPayload(
    "analytics",
    "show",
    apiRequest,
    successActions,
    failActions
  );
}

export function* removeReset(action) {
  if (action.payload?.projectId) {
    yield put(push(`/projects/${action.payload.projectId}/analytics`));
  }
}

/**
 * Saga Watchers
 * The exported list of sagas registered. When one of the action types is dispatched
 * the related worker saga is invoked.
 * Each saga is executed in a different thread
 */
function* analyticsSaga() {
  yield takeEvery(actions.show, show);
  yield takeEvery(actions.removeReset, removeReset);
}
export default analyticsSaga;
